/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Title_SvrInputs */

const en_title_svr = /** @type {(inputs: Title_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site visit report`)
};

const ja_title_svr = /** @type {(inputs: Title_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訪問レポート`)
};

const fr_title_svr = /** @type {(inputs: Title_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport de visite`)
};

const de_title_svr = /** @type {(inputs: Title_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsatzbericht`)
};

/**
* | output |
* | --- |
* | "Site visit report" |
*
* @param {Title_SvrInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const title_svr = /** @type {((inputs?: Title_SvrInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Title_SvrInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_title_svr(inputs)
	if (locale === "ja") return ja_title_svr(inputs)
	if (locale === "fr") return fr_title_svr(inputs)
	return de_title_svr(inputs)
});